import { PlusOutlined } from '@ant-design/icons'
import React from 'react'

import ViewFileRecord from './ViewFileRecord'
import ANTDButton from '../../../../../shared/antd/ANTDButton'
import ANTDCard from '../../../../../shared/antd/ANTDCard'
import ANTDForm, { ANTDFormItem } from '../../../../../shared/antd/ANTDForm'
import ANTDModal from '../../../../../shared/antd/ANTDModal'
import ANTDTable from '../../../../../shared/antd/ANTDTable'
import { successSvg } from '../../../../../utils/icons'
import { length } from '../../../../../utils/javascript'
import FormUpload from '../../../../common/presentation/FormUpload'
import jobContext from '../../../container/jobContext.container'
import '../../../jobs.scss'
import bulkUpload from '../container/bulkUpload.container'

const BulkUpload = () => {
  const { onFileUploadOrRemove } = jobContext()

  const {
    t,
    form,
    viewModal,
    fileUploadDetailsModal,
    columns,
    viewColumns,
    titleFn,
    onFinish,
    bulkUploadList,
    PAGE_SIZE,
    handleChange,
    handleSingleViewChange,
    handleCloseModal,
    handleFileUploadDetailsClose,
    handleFileUploadDetailsTableChange,
    transformFileUploadDetailsData,
    uploadLoader,
    downloadLoader,
    uploadFile,
    onDownloadTemplate,
    getInstruction,
    fileUploadColumns,
    successPopupModal,
    handleSuccessPopupModalClose,
  } = bulkUpload({ onFileUploadOrRemove })

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>{t('btn_ChooseFile')}</div>
    </div>
  )

  const dispatchJobInstruction = instructions => {
    return (
      <ul style={{ lineHeight: '2', paddingLeft: '20px', fontSize: '15px' }}>
        {instructions.map((instruction, index) => (
          <li key={index} dangerouslySetInnerHTML={{ __html: instruction }} />
        ))}
      </ul>
    )
  }

  return (
    <>
      <h1>{titleFn()}</h1>

      <ANTDCard className="mt-30">
        <div className="bulk-upload-instruction">
          <div style={{ paddingLeft: '20px' }}>
            <h2 className="mb-10">{t('job_Instructions')}</h2>
            {dispatchJobInstruction(getInstruction())}
            <div className="mt-20 ml-15">
              <ANTDButton
                type="primary"
                className="btn text-center"
                onClick={onDownloadTemplate}
                loading={downloadLoader}
              >
                {t('job_DownloadTemplate')}
              </ANTDButton>
            </div>
          </div>
          <div style={{ width: '30%', minWidth: '300px' }} className="mt-20">
            <ANTDForm
              name="bulk-upload"
              initialValues={{}}
              form={form}
              layout="vertical"
              onFinish={onFinish}
              className="w-100 d-flex justify-center align-center flex-column"
            >
              <div className="bulk-upload">
                <ANTDFormItem name="uploadFile">
                  <FormUpload
                    className="nameplate-image m-auto"
                    takePhotoFlag={false}
                    acceptFileTypes={'.xlsx,.xls'}
                    uploadButton={uploadButton}
                    form={form}
                    name="uploadFile"
                    max={1}
                  />
                </ANTDFormItem>
              </div>

              <ANTDButton
                type="primary"
                className="btn text-center"
                htmlType="submit"
                loading={uploadLoader}
                disabled={!uploadFile || !length(uploadFile?.fileList)}
              >
                {t('txt_Upload')}
              </ANTDButton>
            </ANTDForm>
          </div>
        </div>
      </ANTDCard>

      <h2 className="mt-30 mb-10">{t('job_UploadHistory')}</h2>

      <ANTDTable
        columns={columns}
        dataSource={length(bulkUploadList?.list) ? bulkUploadList?.list : []}
        pagination={{
          lastFetched: bulkUploadList?.pageNo,
          current: bulkUploadList?.pageNo,
          pageSize: PAGE_SIZE,
          total: bulkUploadList?.lastPage * PAGE_SIZE,
          responsive: true,
        }}
        scroll={{
          x: '100%',
        }}
        loading={bulkUploadList?.loader}
        onChange={handleChange}
      />

      {viewModal?.open && (
        <ViewFileRecord
          {...{
            t,
            viewModal,
            handleCloseModal,
            handleSingleViewChange,
            viewColumns,
            PAGE_SIZE,
          }}
        />
        // <ANTDModal
        //   title={t('txt_FileRecords')}
        //   centered
        //   open={viewModal?.open}
        //   onCancel={() => setViewModal({ open: false })}
        //   footer={false}
        //   width={1100}
        // >
        //   <ANTDTable
        //     columns={viewColumns}
        //     dataSource={viewModal?.data?.list || []}
        //     pagination={{
        //       lastFetched: viewModal?.data?.pageNo,
        //       current: viewModal?.data?.pageNo,
        //       pageSize: PAGE_SIZE,
        //       total: viewModal?.data?.lastPage * PAGE_SIZE,
        //       responsive: true,
        //     }}
        //     scroll={{
        //       x: 700,
        //     }}
        //     onChange={handleSingleViewChange}
        //   />
        // </ANTDModal>
      )}

      {fileUploadDetailsModal?.open && (
        <ANTDModal
          title={t('txt_FileRecords')}
          centered
          open={fileUploadDetailsModal?.open}
          onCancel={handleFileUploadDetailsClose}
          footer={false}
          width={1100}
        >
          <ANTDTable
            columns={fileUploadColumns || []}
            dataSource={transformFileUploadDetailsData(
              fileUploadDetailsModal?.data?.list || [],
              fileUploadDetailsModal?.jobType,
            )}
            pagination={{
              lastFetched: fileUploadDetailsModal?.data?.pageNo,
              current: fileUploadDetailsModal?.data?.pageNo,
              pageSize: 10,
              total: fileUploadDetailsModal?.data?.lastPage * 10,
              responsive: true,
            }}
            scroll={{
              x: 700,
            }}
            loading={fileUploadDetailsModal?.loader}
            onChange={handleFileUploadDetailsTableChange}
          />
        </ANTDModal>
      )}

      {successPopupModal && (
        <ANTDModal
          centered
          open={successPopupModal}
          onCancel={handleSuccessPopupModalClose}
          title={false}
          className="upload-success-modal"
          footer={
            <div className="upload-success-modal__footer">
              <ANTDButton
                type="primary"
                className="upload-success-modal__btn"
                onClick={handleSuccessPopupModalClose}
              >
                {t('msg_OK')}
              </ANTDButton>
            </div>
          }
        >
          <div className="upload-success-modal__body">
            <div className="upload-success-modal__icon">
              <img src={successSvg} alt="success" width="190" />
            </div>
            <div className="upload-success-modal__title">
              {t('txt_UploadComplete')}
            </div>
            <div className="upload-success-modal__desc">
              {t('msg_FileUploadedSuccessfully')}
            </div>
          </div>
        </ANTDModal>
      )}
    </>
  )
}

export default BulkUpload
